export default __webpack_public_path__ + "static/media/thumbnail.674c13f0.jpg";